import {
  Typography,
  Box,
  Link,
  Stack,
  Button,
  Grid,
  Card,
} from "@mui/material";
import { useTitle } from "utils/UseTitle";
import {
  handleErrorMessage,
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "helpers/methods";
import { useState } from "react";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import title from "global/constants/TitleConstants";
import { resendAccountVerificationNotification } from "./AuthService";
import AuthLayout from "layouts/AuthLayout/AuthLayout";
import Logo from "assets/images/light_side_nav_mailzzy_logo.svg";
import GmailIcon from "assets/icons1/GmailIcon.svg";
import OutlookIcon from "assets/icons1/OutlookIcon.svg";
import YahooIcon from "assets/icons1/YahooIcon.svg";
import AppleMailIcon from "assets/icons1/AppleMailIcon.svg";

const RegistrationSuccessModal = (props: { location: any }) => {
  useTitle(title.CHECK_YOUR_EMAIL);
  const email = props.location?.state?.email;
  const [isLoading, setIsLoading] = useState<boolean>();

  const resendAccountVerificationEmail = async () => {
    try {
      setIsLoading(true);
      if (!isTruthy(email)) {
        openErrorNotification("Kindly use the original link for activation!");
        return;
      } else {
        await resendAccountVerificationNotification(email);
        openSuccessNotification("Account activation email sent successfully!");
      }
    } catch (error: any) {
      handleErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            pb: "30px",
          }}
        >
          <img src={Logo} width="180px" alt="Mailzzy_logo" />
        </Box>
        <Card
          elevation={20}
          sx={{
            padding: "28px 28px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            color="#475569"
            fontWeight={600}
            gutterBottom
          >
            Awesome! Please verify your email.
          </Typography>
          <Typography variant="body1" color="#475569" gutterBottom>
            Please check your inbox and click on the activation link to complete
            the email verification process
          </Typography>
          <Grid container spacing={2} py={1.5}>
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Button
                  variant="outlined"
                  startIcon={<img src={GmailIcon} alt="Gmail" />}
                  onClick={() => {
                    window.open(
                      "https://mail.google.com/mail/u/0/#advanced-search/from=info%40mailzzy.com",
                      "_blank"
                    );
                  }}
                >
                  Open Gmail
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<img src={OutlookIcon} alt="Outlook" />}
                  onClick={() => {
                    window.open("https://outlook.office.com/mail/", "_blank");
                  }}
                >
                  Open Outlook
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Button
                  variant="outlined"
                  startIcon={<img src={YahooIcon} alt="Yahoo" />}
                  onClick={() => {
                    window.open(
                      "https://mail.yahoo.com/d/search/keyword=from%253Ainfo%2540mailzzy.com",
                      "_blank"
                    );
                  }}
                >
                  Open Yahoo
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<img src={AppleMailIcon} alt="Appple" />}
                  onClick={() => {
                    window.open("https://www.icloud.com/mail/", "_blank");
                  }}
                >
                  Open Apple Mail
                </Button>
              </Stack>
            </Grid>
          </Grid>
          <Typography variant="body2" color="#475569">
            Haven't received an email? Be sure to check your spam folder or
            <Link
              component="a"
              onClick={resendAccountVerificationEmail}
              sx={{
                cursor: "pointer !important",
                pl: 0.5,
                textDecoration: "underline",
              }}
            >
              resend
            </Link>
            .
          </Typography>
        </Card>
        <CustomLoader isLoading={isLoading} />
      </Box>
    </AuthLayout>
  );
};

export default RegistrationSuccessModal;
